function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.5001 6.50004C6.5001 6.77618 6.27624 7.00004 6.0001 7.00004C5.72395 7.00004 5.5001 6.77618 5.5001 6.50004V5.50004C5.5001 5.22389 5.72395 5.00004 6.0001 5.00004C6.27624 5.00004 6.5001 5.22389 6.5001 5.50004V6.50004Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5001 8.50004C5.5001 8.22389 5.72395 8.00004 6.0001 8.00004C6.27624 8.00004 6.5001 8.22389 6.5001 8.50004C6.5001 8.77618 6.27624 9.00004 6.0001 9.00004C5.72395 9.00004 5.5001 8.77618 5.5001 8.50004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19137 10.5C1.43076 10.5 0.948601 9.68457 1.31515 9.01812L5.12388 2.09316C5.50381 1.40238 6.49638 1.40238 6.87631 2.09315L10.685 9.01812C11.0516 9.68457 10.5694 10.5 9.80882 10.5H2.19137ZM6.0001 2.60004L2.2351 9.4474H9.7651L6.0001 2.60004Z"
  }));
};

export default SvgComponent;